import i18n from '@/i18n'

i18n.mergeLocaleMessage('en', {
    'fireapps_expert': {
    }
})